(function () {
  var container = document.querySelector('.team-members-container');
  var wrapper = document.querySelector('.team-members-wrapper');
  if (!wrapper) return;

  // Fade up on scroll
  if (container) {
    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        container.classList.add('_visible');
      } else {
        container.classList.remove('_visible');
      }
    }, { rootMargin: '-100px 0px' });
    observer.observe(container);
  }

  var allCards = wrapper.querySelectorAll('._card');
  if (!allCards.length) return;

  // Always make first card active
  allCards[0].classList.add('is-active');

  var prevBtn = document.querySelector('.tm-prev');
  var nextBtn = document.querySelector('.tm-next');
  var dots = document.querySelectorAll('.tm-dot');
  var resizeTimer;

  function getConstrainedHeight(imageContainer) {
    var styles = window.getComputedStyle(imageContainer);
    var height = Math.ceil(
      imageContainer.getBoundingClientRect().height +
      parseFloat(styles.marginTop) +
      parseFloat(styles.marginBottom)
    );
    return window.innerWidth <= 550 ? height + 250 : height;
  }

  function setCopyHeights() {
    var wrapperWidth = wrapper.offsetWidth;

    // Batch write: temporarily show all cards
    allCards.forEach(function (card) {
      card.style.cssText = 'display:flex;visibility:hidden;position:absolute;width:' + wrapperWidth + 'px;min-height:';
    });

    // Batch read + write per card, then measure tallest
    var tallest = 0;
    allCards.forEach(function (card) {
      var imageContainer = card.querySelector('._image-container');
      var copyContainer = card.querySelector('._copy-container');
      var btn = card.querySelector('.read-more-btn');
      if (!imageContainer || !copyContainer) return;

      var constrainedHeight = getConstrainedHeight(imageContainer);

      copyContainer.style.height = 'auto';
      var naturalHeight = copyContainer.scrollHeight;

      if (!btn || !btn.classList.contains('_active')) {
        copyContainer.style.height = constrainedHeight + 'px';
      }

      if (btn) {
        var shouldShow = naturalHeight > constrainedHeight;
        btn.classList.toggle('_show', shouldShow);
        if (shouldShow && !btn.classList.contains('_active')) {
          copyContainer.classList.add('_closed');
        }
      }

      if (card.offsetHeight > tallest) tallest = card.offsetHeight;
    });

    // Batch write: restore display state and apply min-height
    var minHeight = tallest + 'px';
    allCards.forEach(function (card) {
      card.style.cssText = 'min-height:' + minHeight;
    });
  }

  document.addEventListener('DOMContentLoaded', setCopyHeights);
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      requestAnimationFrame(setCopyHeights);
    }, 100);
  });

  // Read More toggle
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.read-more-btn');
    if (!btn) return;

    var card = btn.closest('._card');
    var copyContainer = card.querySelector('._copy-container');
    if (!copyContainer) return;

    var btnText = btn.querySelector('._text');

    if (btn.classList.contains('_active')) {
      btn.classList.remove('_active');
      if (btnText) btnText.textContent = 'Read More';
      copyContainer.classList.remove('_open');
      copyContainer.classList.add('_closed');
      copyContainer.style.height = copyContainer.scrollHeight + 'px';
      copyContainer.offsetHeight;
      copyContainer.style.height = getConstrainedHeight(card.querySelector('._image-container')) + 'px';
    } else {
      btn.classList.add('_active');
      if (btnText) btnText.textContent = 'Show Less';
      copyContainer.classList.remove('_closed');
      copyContainer.classList.add('_open');
      copyContainer.style.height = copyContainer.scrollHeight + 'px';
      setTimeout(function () {
        copyContainer.style.height = 'auto';
      }, 350);
    }
  });

  // Carousel
  if (allCards.length >= 2 && prevBtn && nextBtn) {
    var current = 0;
    var animating = false;

    function updateDots(index) {
      dots.forEach(function (dot) { dot.classList.remove('_active'); });
      if (dots[index]) dots[index].classList.add('_active');
    }

    function closeReadMore(card) {
      var btn = card.querySelector('.read-more-btn');
      if (!btn || !btn.classList.contains('_active')) return;
      btn.classList.remove('_active');
      var btnText = btn.querySelector('._text');
      if (btnText) btnText.textContent = 'Read More';
      var copyContainer = card.querySelector('._copy-container');
      if (!copyContainer) return;
      copyContainer.classList.remove('_open');
      copyContainer.classList.add('_closed');
      copyContainer.style.height = getConstrainedHeight(card.querySelector('._image-container')) + 'px';
    }

    function goTo(newIndex, direction) {
      if (animating || newIndex === current) return;
      closeReadMore(allCards[current]);
      animating = true;

      var outgoing = allCards[current];
      var incoming = allCards[newIndex];
      var outClass = direction === 'next' ? 'slide-out-left' : 'slide-out-right';
      var inClass = direction === 'next' ? 'slide-in-right' : 'slide-in-left';

      outgoing.classList.add('is-animating', outClass);
      outgoing.classList.remove('is-active');
      incoming.classList.add('is-active', inClass);
      updateDots(newIndex);

      outgoing.addEventListener('animationend', function handler() {
        outgoing.removeEventListener('animationend', handler);
        outgoing.classList.remove('is-animating', 'slide-out-left', 'slide-out-right');
        incoming.classList.remove('slide-in-right', 'slide-in-left');
        current = newIndex;
        animating = false;
        requestAnimationFrame(setCopyHeights);
      });
    }

    prevBtn.addEventListener('click', function () {
      goTo((current - 1 + allCards.length) % allCards.length, 'prev');
    });

    nextBtn.addEventListener('click', function () {
      goTo((current + 1) % allCards.length, 'next');
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-index'), 10);
        goTo(index, index > current ? 'next' : 'prev');
      });
    });
  }
})();
